// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insights{margin-top:20px}.insights__table-body{position:relative}.insights__download-length{color:var(--color-eggplant)}", ""]);
// Exports
module.exports = exports;
